import { Controller } from "@hotwired/stimulus"
import { FUN_MUSIC_EVENT, writeFunMusic } from "../utils/fun_settings"

// Le bouton « Musique » de la carte de contexte de la barre latérale (cf.
// SidebarComponent::ContextBandeauComponent), affiché pour les skins qui ont une musique.
//
// Il ne joue rien lui-même : il range le choix (un seul pour tous les skins) et laisse
// `syncFunMusic` décider — la musique a d'autres raisons de se taire (un skin silencieux, un onglet
// caché). Son libellé suit ce qu'on entend, pas ce qu'on a demandé : une musique voulue mais pas
// encore permise par le navigateur (avant le premier geste) se lance d'un clic. Et sa note bat la
// mesure au tempo de la piste (`--fun-music-beat`, cf. components/_fun_skins.scss).
export default class extends Controller {
  static targets = ["label"]
  static values = { playLabel: String, stopLabel: String }

  connect() {
    // La musique vit dans le module chargé à la demande (utils/fun_extras.js).
    this.extras = import("../utils/fun_extras")
    this.onMusic = () => this.reflect()
    window.addEventListener(FUN_MUSIC_EVENT, this.onMusic)
    this.reflect()
  }

  disconnect() {
    window.removeEventListener(FUN_MUSIC_EVENT, this.onMusic)
  }

  toggle() {
    this.extras.then((extras) => {
      writeFunMusic(!extras.isFunMusicPlaying())
      extras.syncFunMusic()
      this.reflect()
    })
  }

  reflect() {
    this.extras.then((extras) => {
      const playing = extras.isFunMusicPlaying()
      const tempo = extras.funMusicTempo()
      this.element.setAttribute("aria-pressed", String(playing))
      if (tempo) this.element.style.setProperty("--fun-music-beat", `${(60 / tempo).toFixed(3)}s`)
      if (this.hasLabelTarget) this.labelTarget.textContent = playing ? this.stopLabelValue : this.playLabelValue
    })
  }
}
